// extracted by mini-css-extract-plugin
export default {"pageTitle":"edit-resource-type_pageTitle__714yv","statusPanel":"edit-resource-type_statusPanel__nrZCd"};